import {
  Bell,
  Gauge,
  Users,
  type LucideIcon,
} from 'lucide-react';

export type NavigationItem = {
  to: string;
  labelKey: string;
  icon: LucideIcon;
  disabled?: boolean;
  disabledLabelKey?: string;
};

export const navigationItems: NavigationItem[] = [
  {
    to: '/',
    labelKey: 'sidebar.nav.dashboard',
    icon: Gauge,
  },
  {
    to: '/users',
    labelKey: 'sidebar.nav.userManagement',
    icon: Users,
  },
];

export const topbarActions = [
  {
    id: 'notifications',
    labelKey: 'topbar.notifications',
    icon: Bell,
  },
];
